module.exports = __webpack_public_path__ + "img/apart03.ca5e78e0.png";